import { executeRequest, Request } from '@jfs/network'
import { isEmpty } from '@jfs/utils'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const creditAdjustReq = (data: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.initaiteCrDrAdjudtment,
    body: {
      entity: {
        entityId: data?.entityId, //mandatory MID
      },
      originalId: isEmpty(data?.originalId) ? undefined : data?.originalId, //optional, mandatory only for with O txns
      currency: '356',
      invoice: data?.invoice,
      mode: Number(data?.mode), //mandatory
      captureMethod: Number(data?.captureMethod), //mandatory
      livemode: true,
      application: 8006,
      method: {
        type: data?.methodType, //mandatory
        subType: isEmpty(data?.methodSubType) ? undefined : data?.methodSubType, //optional (conditional)
      },
      amount: {
        netAmount: Number(data?.netAmount), //mandatory
      },
      statementDescriptor: data?.description ?? '',
    },
    method: 'POST',
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { creditAdjustReq }
